import React, { Component } from 'react'
import { connect } from 'react-redux'

// import components
import Modal from '../../components/Modal'

import Button from '../../elements/button'
import Panel from '../../elements/panel'
import Null from '../../elements/null'

// Utils
import { translation } from '../../../utils/helpers'
// actions
import { forgotPassword } from '../../../actions/password'

// styles
import './forgotpasswordmodal.scss'
import Col from '../../elements/col'
import Text from '../../elements/text'

class ForgotPasswordModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      emailSent: false
    }
    this.resetPassword = this.resetPassword.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  onChange (e) {
    this.setState({
      email: e.target.value
    })
  }

  resetPassword () {
    let email = this.state.email
    if (email === '') {
      window.toastr.error(translation('16329'), translation('216'))
      return
    }
    this.props.forgotPassword(email).then((res) => {
      this.setState({
        emailSent: true
      })
    }, (err) => {
      if (err.response.data !== undefined) {
        let error = err.response.data
        // Toastr
        window.toastr.error(translation(error.DictionaryKey), translation('216'))
      }
    })
  }

  onClose () {
    // Close and reset state
    this.setState({emailSent: false, email: ''}, () => {
      this.props.onClose()
    })
  }

  renderContent () {
    if (this.state.emailSent === true) {
      return (
        <div className='content '>
          <Col span={2}>
            <Panel title={translation('16328')}>
              <p>{translation('16325')}</p>
              <Button labelText={translation(956)} onClick={this.onClose} />
            </Panel>
          </Col>
        </div>
      )
    }
    return (
      <div className='content'>
        <Col>
          <Panel title={translation('16321')}>
            <Text labelText={translation('1052')} name='email' value={this.state.email} onChange={this.onChange} />
            <Button labelText={translation('16327')} onClick={this.resetPassword} />
          </Panel>
        </Col>
        <Null><div className='divider' /></Null>
        <Col>
          <Panel title={translation('16322')}>
            <div>
              <li>{translation('16323')}</li>
              <li>{translation('16324')}</li>
              <li>{translation('16325')}</li>
              <li>{translation('16326')}</li>
              <li>{translation('16389')}</li>
            </div>
          </Panel>
        </Col>
      </div>
    )
  }

  render () {
    let modalTitle = this.state.emailSent ? translation('16328') : translation('2144')
    return (
      <div className={'forgotPassword_modal' + (this.state.emailSent ? ' isSent' : '')}>
        <Modal {...this.props} header={modalTitle}>
          {this.renderContent()}
        </Modal>
      </div>
    )
  }
}

export default connect(null, { forgotPassword })(ForgotPasswordModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/ForgotPasswordModal/index.js